import type { TippyProps } from '@tippyjs/react';
import { animateFill } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/animations/shift-away.css';

/** Estilo padrão dos tooltips — mesmo do indicador de conexão Yjs. */
export const TIPPY_TOOLTIP = {
  placement: 'bottom',
  animateFill: true,
  plugins: [animateFill],
  arrow: false,
} as const satisfies Partial<TippyProps>;
